import { PaymentMethodProps } from './PaymentMethod';
import usePaymentFlow from '../../../hooks/payment/usePaymentFlow';
import React, { useMemo } from 'react';
import useAuth from '../../../hooks/global/useAuth';
import usePaymentCoordinator from '../../../hooks/payment/usePaymentCoordinator';
import SavePaymentInfoConsent from './SavePaymentInfoConsent';
import AttachablePaymentMethod from './AttachablePaymentMethod';

export default function PaypalPaymentMethod(props: PaymentMethodProps) {
  const { id } = props;

  const { isLoggedIn } = useAuth();
  const { loading } = usePaymentCoordinator();
  const { loading: blocked, selectedPaymentMethod, paymentOptions, findSavedPaymentMethod } = usePaymentFlow();

  const savedInfo = useMemo(() => findSavedPaymentMethod(id), [paymentOptions]);

  return (
    <AttachablePaymentMethod {...props}>
      {isLoggedIn && selectedPaymentMethod === id && !savedInfo && !loading && !blocked && (
        <div className="p-sm border bg-[#F5F5F5] dark:bg-black">
          <SavePaymentInfoConsent />
        </div>
      )}
    </AttachablePaymentMethod>
  );
}
